import React from 'react';
import { useField } from 'formik';
import { Form } from 'react-bootstrap';

import Input from '../Inputs/Input';

interface FormikInputFieldProps {
  name: string;
  type?: string;
  placeholder?: string;

  onFocus?: React.FocusEventHandler;
  onBlur?: React.FocusEventHandler;
}

const FormikInputField = ({
  name,
  type,
  placeholder,
  onFocus,
  onBlur,
}: FormikInputFieldProps) => {
  const [field, meta, helpers] = useField(name);

  const { value } = field;
  const { setValue } = helpers;

  return (
    <Form.Group>
      <Form.Control
        as={Input}
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={setValue}
        isInvalid={Boolean(meta.error)}
        autoComplete="off"
        custom
      />

      <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
        {meta.error ?? ' '}&nbsp;
      </Form.Control.Feedback>
    </Form.Group>
  );
};

FormikInputField.defaultProps = {
  type: 'text',
  placeholder: '',
  onFocus: () => {},
  onBlur: () => {},
};

export default FormikInputField;
